(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["info-modal"] && !Shopify.designMode) return;
  try {
    // Close dialog when clicking on backdrop
  document.querySelectorAll('.info-modal-block__dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["powerful-ingredients"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pop-wrapper').forEach((wrapper) => {
      const btn = wrapper.querySelector('.pop-button');
      const content = wrapper.querySelector('.pop-content');

      if (!content) return;

      const toggle = () => wrapper.classList.toggle('active');
      const trigger = wrapper.querySelector('[data-popup-trigger]');
      if (trigger) trigger.addEventListener('click', toggle);
      if (btn) btn.addEventListener('click', toggle);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
